<template>
    <section>
        <!-- 待付款、待处理、处理中、待确认、已完成 -->
        <ul class="progress-wrap" v-if="order_status == 1 || order_status == 2 || order_status == 3 || order_status == 13 || order_status == 4 || order_status == 5">
            <li class="one">待付款</li>
            <li :class="order_status == 1?'two':'one'">处理中</li>
            <li :class="order_status == 4 || order_status == 5?'one':'two'">待确认</li>
            <li :class="order_status == 5?'one':'two'">已完成</li>
        </ul>
        
        <ul class="progress-wrap" v-else>
            <li class="one">待付款</li>
            <li class="one">处理中</li>
            <li class="one" v-if="order_status == 6">已撤单</li>
            <li class="one" v-if="order_status == 7">已取消</li>
            <li class="one" v-if="order_status == 8">已驳回</li>
            <li class="one" v-if="order_status == 9">已退款</li>
            <li class="one" v-if="order_status == 10">退款中</li>
            <li class="one" v-if="order_status == 11">未解决</li>
        </ul>
    </section>
</template>

<script>
export default {
    props: {
        order_status: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.progress-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    li {
        width: 252px;
        height: 33px;
        text-align: center;
        margin-right: 20px;
        line-height: 33px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
    }
    li:last-child {
        margin-right: 0;
    }
    .one {
        background: url(../../../assets/img/progress-dark.png) no-repeat center;
        background-size: 100%;
        color: #ffffff;
    }
    .two {
        background: url(../../../assets/img/progress.png) no-repeat center;
        background-size: 100%;
        color: #cccccc;
    }
}
</style>
